// src/app/modules/Dashbord/_redux/dashboard/Crud.developer.js
import axios from "axios";
import config from "../../../../../config";

const BASE = config.URL;

// ── Meta ──────────────────────────────────────────────────────────────────────

export const listScopes     = ()      => axios.get(`${BASE}developer/scopes`);
export const listEventTypes = ()      => axios.get(`${BASE}developer/events`);

// ── API Keys ──────────────────────────────────────────────────────────────────

export const listApiKeys = (organization_id) =>
  axios.get(`${BASE}developer/keys`, { params: { organization_id } });

export const createApiKey = (data) =>
  axios.post(`${BASE}developer/keys`, data);
// data: { organization_id, name, scopes[], expires_in_days? }

export const updateApiKey = (keyId, data) =>
  axios.patch(`${BASE}developer/keys/${keyId}`, data);
// data: { name?, scopes?, is_active? }

export const revokeApiKey = (keyId, organization_id) =>
  axios.delete(`${BASE}developer/keys/${keyId}`, { params: { organization_id } });

// ── Webhooks ──────────────────────────────────────────────────────────────────

export const listWebhooks = (organization_id) =>
  axios.get(`${BASE}developer/webhooks`, { params: { organization_id } });

export const createWebhook = (data) =>
  axios.post(`${BASE}developer/webhooks`, data);
// data: { organization_id, url, events[], description? } 

export const updateWebhook = (endpointId, data) =>
  axios.patch(`${BASE}developer/webhooks/${endpointId}`, data);

export const deleteWebhook = (endpointId, organization_id) =>
  axios.delete(`${BASE}developer/webhooks/${endpointId}`, { params: { organization_id } });

export const rotateWebhookSecret = (endpointId, organization_id) =>
  axios.post(`${BASE}developer/webhooks/${endpointId}/rotate-secret`, { organization_id });

export const listDeliveries = (endpointId, params) =>
  axios.get(`${BASE}developer/webhooks/${endpointId}/deliveries`, { params });
// params: { organization_id, page?, limit? }

export const retryDelivery = (deliveryId, organization_id) =>
  axios.post(`${BASE}developer/webhooks/deliveries/${deliveryId}/retry`, { organization_id });